module.exports = __webpack_public_path__ + "e6faa5e8f19bbdb423115846321c7bf4.MP3";